import './user-menu.scss';

import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import classnames from 'classnames';

class UserMenu extends React.PureComponent {

  state = {
    isDropdownOpen: false,
  };

  onDocumentClick = (evt) => {
    if (this.state.isDropdownOpen) {
      if (!evt.target.closest('.user-menu__dropdown')) {
        // The user has clicked somewhere other than within
        // the dropdown menu.
        this.closeDropdown();
      }
    }
  };

  onEmailClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    this.openDropdown();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isDropdownOpen !== prevState.isDropdownOpen) {
      if (this.state.isDropdownOpen) {
        document.addEventListener('click', this.onDocumentClick);
      } else {
        document.removeEventListener('click', this.onDocumentClick);
      }
    }
  }

  componentWillUnmount() {
    if (this.isDropdownOpen) {
      document.removeEventListener('click', this.onDocumentClick);
    }
  }

  openDropdown() {
    this.setState({
      isDropdownOpen: true,
    });
  }

  closeDropdown() {
    this.setState({
      isDropdownOpen: false,
    });
  }

  /**
   * @returns {JSX.Element}
   */
  renderDropdown() {
    const { isLogoutOnly } = this.props;

    return (
      <div className="user-menu__dropdown">
        <ul className="user-menu__dropdown-list">
          {!isLogoutOnly && (
            <li className="user-menu__dropdown-list-item">
              <a href="/home/myAccount" className="user-menu__dropdown-link">
                <FormattedMessage
                  id=""
                  description="A link which will send the user to their settings page."
                  defaultMessage="My Settings" />
              </a>
            </li>
          )}
          <li className="user-menu__dropdown-list-item">
            <a href="/account/logOut" className="user-menu__dropdown-link" data-testid="logout-menu-button">
              <FormattedMessage
                id=""
                description="A link which will log the current user out."
                defaultMessage="Logout" />
            </a>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    const { isDropdownOpen } = this.state;
    const { user } = this.props;

    const classes = classnames('user-menu', {
      'user-menu--is-open': isDropdownOpen,
    });

    return (
      <div className={classes}>
        <div className="user-menu__user">
          <a href="" className="user-menu__user-email" onClick={this.onEmailClick}>
            {user.emailAddress}
          </a>
        </div>
        {isDropdownOpen && this.renderDropdown()}
      </div>
    );
  }
}

export default injectIntl(UserMenu);
